import { CARD_TYPE, CARD_DISPLAY_NAME } from './cardConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: CARD_TYPE,
        content: {
            textContent: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: CARD_TYPE,
        objectConstructorFn,
        displayName: CARD_DISPLAY_NAME,
        ...params,
    });
